const initialState = {
  purge: {
    isLoading: false,
    isPurging: false,
    isOpen: false,
    data: {},
    error: '',
  },
  show: {
    isLoading: false,
    data: {},
    error: '',
  },
  settings: {
    general: {
      isLoading: false,
      data: {},
      error: '',
    },
    updateName: {
      isLoading: false,
      error: '',
    },

    snapshots: {
      create: {
        isLoading: false,
        error: '',
      },
      list: {
        isLoading: false,
        error: '',
        data: {
          count: 0,
          items: [],
        },
      },
      download: {
        isLoading: false,
        error: '',
      },
      rollback: {
        isLoading: false,
        error: '',
      },
    },
    versionControl: {
      isLoading: false,
      error: '',
    },
  },
  export: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
